module.exports = __webpack_public_path__ + "images/icons/flags/DK-4685f4b9.svg";